import "./index.css";
import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { Container as t } from "@design-system/container";
import { Link as s } from "@design-system/link";
import { Section as r } from "@design-system/section";
import { Typography as a } from "@design-system/typography";
import { forwardRef as n } from "react";

function o(e, i) {
  var t = {};

  for (var s in e) {
    Object.prototype.hasOwnProperty.call(e, s) && i.indexOf(s) < 0 && (t[s] = e[s]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (s = Object.getOwnPropertySymbols(e); r < s.length; r++) {
      i.indexOf(s[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, s[r]) && (t[s[r]] = e[s[r]]);
    }
  }

  return t;
}

var c = n(function (_ref, b) {
  var n = _ref.className,
      _ref$mode = _ref.mode,
      c = _ref$mode === void 0 ? "default" : _ref$mode,
      _ref$LinkNavElement = _ref.LinkNavElement,
      l = _ref$LinkNavElement === void 0 ? s : _ref$LinkNavElement,
      m = _ref.navigationData,
      d = _ref.disclaimer,
      f = _ref.copyright,
      g = _ref.iconsData,
      p = _ref.iconsHeading;
  return e(r, Object.assign({
    ref: b,
    mode: c,
    element: "footer",
    className: n,
    removeAllSpacing: !0
  }, {
    children: i(t, Object.assign({
      maxWidth: "max-grid",
      className: "cds-footer"
    }, {
      children: [e("ul", Object.assign({
        className: "cds-footer__nav-list"
      }, {
        children: m.map(function (i) {
          var t = i.href,
              _i$variant = i.variant,
              s = _i$variant === void 0 ? "subtle" : _i$variant,
              _i$size = i.size,
              r = _i$size === void 0 ? "large" : _i$size,
              a = o(i, ["href", "variant", "size"]);
          return e("li", {
            children: e(l, Object.assign({
              variant: s,
              href: t,
              size: r
            }, a))
          }, t);
        })
      })), i("div", Object.assign({
        className: "cds-footer__social"
      }, {
        children: [!!(null == g ? void 0 : g.length) && i("div", {
          children: [p && e(a, Object.assign({}, p, {
            id: "social-networks-label-id"
          })), e("ul", Object.assign({
            "aria-labelledby": "social-networks-label-id",
            className: "cds-footer__icon-list"
          }, {
            children: g.map(function (i) {
              var t = i.href,
                  _i$variant2 = i.variant,
                  s = _i$variant2 === void 0 ? "subtle-icon" : _i$variant2,
                  _i$size2 = i.size,
                  r = _i$size2 === void 0 ? "small" : _i$size2,
                  a = o(i, ["href", "variant", "size"]);
              return e("li", {
                children: e(l, Object.assign({
                  className: "cds-footer__icon-list-item",
                  variant: s,
                  href: t,
                  size: r
                }, a))
              }, t);
            })
          }))]
        }), f && e(a, {
          className: "cds-footer__copyright",
          content: f,
          variant: "bodyXS"
        })]
      })), d && e("div", Object.assign({
        className: "cds-footer__disclaimer"
      }, {
        children: e(a, {
          className: "cds-footer__disclaimer-content",
          content: d,
          variant: "bodyS"
        })
      }))]
    }))
  }));
});
export { c as Footer };